import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyBzltEBLgJEqkzuOLnx2meJNt2xnApGFSg", // If needed for security reasons - it can be moved to .env file
    authDomain: "test-device-tracker-7c5bc.firebaseapp.com",
    projectId: "test-device-tracker-7c5bc",
    storageBucket: "test-device-tracker-7c5bc.firebasestorage.app",
    messagingSenderId: "1093291094339",
    appId: "1:1093291094339:web:4b10bd8815dafe86fd3ff6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app);

export { app, auth, provider, db };
